import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { formatAmount } from '../../utility/certificationBuilder'

import classes from './CertificationCard.module.scss'

const statusKey = (certification) => {
  if (certification.published) { return 'published' }
  return certification.sectionsCount > 0 ? 'draft' : 'planned'
}

const CertificationCard = ({ certification }) => {
  const { t } = useTranslation()
  const hasContent = certification.sectionsCount > 0
  const price = certification.defaultPrice

  return (
    <Link to={`/certifications/${certification.id}`} className={classes.card}>
      <div className={`position-relative ${classes.cover}`}>
        {certification.coverImage && (
          <img src={certification.coverImage.largeFileUrl} alt='' className={classNames(classes.image, { [classes.imageDimmed]: !hasContent })} />
        )}
        <span className={classNames(classes.badge, { [classes.badgePublished]: certification.published })}>
          {t(`certificationBuilder.page.${statusKey(certification)}`)}
        </span>
      </div>
      <div className={classes.body}>
        <div className={classes.title}>{certification.name}</div>
        <div className={classes.meta}>
          {hasContent
            ? t('certificationBuilder.list.meta', { sections: certification.sectionsCount, lessons: certification.lessonsCount })
            : t('certificationBuilder.list.noContent')}
        </div>
        <div className={classNames('text-right', classes.footer)}>
          <span className={classes.price}>{price ? formatAmount(price) : t('certificationBuilder.list.noPrice')}</span>
        </div>
      </div>
    </Link>
  )
}

CertificationCard.propTypes = {
  certification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    published: PropTypes.bool.isRequired,
    sectionsCount: PropTypes.number.isRequired,
    lessonsCount: PropTypes.number.isRequired,
    coverImage: PropTypes.shape({ largeFileUrl: PropTypes.string }),
    defaultPrice: PropTypes.shape({
      amount: PropTypes.string.isRequired,
      currency: PropTypes.shape({ code: PropTypes.string.isRequired, symbol: PropTypes.string.isRequired }).isRequired,
    }),
  }).isRequired,
}

export default CertificationCard
